import React, { useState } from "react";
import './index.scss';
import SectionHeader from "../SectionHeader";
import { CREDIT_PRODUCT_TYPE, ROUTE_PATH } from "@/utils/Global";
import DataStorage from "@/utils/DataManager/DataStorage";
import i18n from "@/i18n";
import FunctionCard from "../FunctionCard";

const AiToolsSection = ({ history }) => {
    const aiToolDatas1 = [
        DataStorage.GetAiToolData(CREDIT_PRODUCT_TYPE.REMOVE_BG),
        DataStorage.GetAiToolData(CREDIT_PRODUCT_TYPE.UPSCALING),
        DataStorage.GetAiToolData(CREDIT_PRODUCT_TYPE.EXTEND_IMG),
        DataStorage.GetAiToolData(CREDIT_PRODUCT_TYPE.GENERATE_COPY),
    ].filter(item => item !== undefined)
    const aiToolDatas2 = [
        DataStorage.GetAiToolData(CREDIT_PRODUCT_TYPE.GENERATE_BG_RELIGHT),
        DataStorage.GetAiToolData(CREDIT_PRODUCT_TYPE.ERASE_OBJ),
        DataStorage.GetAiToolData(CREDIT_PRODUCT_TYPE.INPAINT),
    ].filter(item => item !== undefined)

    const handleClickItem = (routePath) => {
        history.push(routePath)
    }

    return (
        <div className="ai-tools-section-wrapper">
            <SectionHeader title="AI Tools" descriptions={[i18n.t("web.pc.landing.2025.ai.tools.header.des")]}
                onClickButton={() => handleClickItem(ROUTE_PATH.AI_TOOLS)}
            />
            <div className="ai-tools-section-content">
                <div className="ai-tools-section-item-row">
                    {
                        aiToolDatas1.map((aiToolData) => (
                            <FunctionCard {...aiToolData} isSmallCard={true} />
                        ))
                    }
                </div>
                <div className="ai-tools-section-item-row">
                    {
                        aiToolDatas2.map((aiToolData) => (
                            <FunctionCard {...aiToolData} isSmallCard={true} />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default AiToolsSection;